import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProjectsAct, fPkgsAct, clearQuoteSearch } from '../redux/project/projActions';
import { showCopyProj, showLoader, showPkgsAct } from '../redux/ctrl/ctrlActions';
import { MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoCopyOutline } from "react-icons/io5";
import { BsStarFill, BsStar } from "react-icons/bs";
import { showUpdProj } from '../redux/ctrl/ctrlActions';
import StyledTooltip from '../shared/toolTip/StyledTooltip';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import './pcards.scss';
import ProjGrid from './pgrid';
import CopyProject from '../createProject/copyProject';
import { getPrjStatus, getDtfrmt } from '../../utils';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { Grid } from '@mui/material';
import { color } from '@mui/system';
import { useTranslation } from 'react-i18next';
import COLORS from '../styles/COLORS';

const ProjectCards = (data) => {
    let eid = data.data.email;
    // const history=useHistory();
    const navigate = useNavigate();
    const profileState = useSelector((state) => state.profile);
    const quoteSearchResults = useSelector((state) => state.project.quoteSearchResults);
    const dispatch = useDispatch();
    const prof = useSelector((state) => state.profile);
    let projAssnData = useSelector((state) => state?.prjasn?.projectsAsn?.filter(i => i.email_id == prof.email && i.end_date != null && new Date(i.end_date).getTime() < new Date().getTime()).map(o => o.project_id));
    const { t, i18n } = useTranslation();
    const ctrlState = useSelector((state) => state.ctrl)
    const proj = useSelector((state) => state.crtl);
    const eProj = { ...proj }
    const [uProj, setProj] = useState(eProj);
    const projStat = useSelector((state) => state.ctrl.projStatus)
    const isCopyCapb = profileState?.capb?.findIndex((o)=>o.PWSCPPRJ==='Y')>=0 ? true : false


    const filterProjects = (projects, filterData, projAssnData) => {
        const filterCondition = (project) => {
            const projectNameMatches = typeof filterData === 'string' && project.project_name.toLowerCase().includes(filterData.toLowerCase());
            const projectNumberMatches = typeof filterData === 'string' && project.project_number.toLowerCase().includes(filterData.toLowerCase());
            const projectId = Array.isArray(filterData) && filterData.includes(project.project_id)
            return (
                (projectNameMatches || projectNumberMatches || projectId) &&
                project.readcol !== 'N' &&
                //   project.writecol !== 'N' &&
                !projAssnData.some((id) => project.project_id === id)
            );
        };

        // if (!prof.appAcc[0].secondary_office) {
        //   return projects.filter(filterCondition);
        // }

        return projects.filter((project) => filterCondition(project) && project.operating_unit === prof.bu);
    };

    const projData = useSelector((state) => {
        const projectData = state.project.projects;
        const findProj = data.findProj || "";
        return filterProjects(projectData, findProj, projAssnData);
    });

    const onCardClick = (e) => {
        eProj.showPkgs = true;
        eProj.data = e;
        setProj(eProj)
        dispatch(showPkgsAct(eProj))
        dispatch(showLoader(true))
        // history.push('/pkgs')
        let url = '/pkgs'
       if(quoteSearchResults?.package){
          const queryParams = new URLSearchParams();
          if (data.advanceSearchFields.package_name) {
              queryParams.append('package_name', data.advanceSearchFields.package_name);
          }
          if (data.advanceSearchFields.quote_number) {
              queryParams.append('quote_number', data.advanceSearchFields.quote_number);
          }
          const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
          url = `/pkgs${query}`
          dispatch(clearQuoteSearch())                    
      }
        navigate(url)
        // dispatch(fPkgsAct({pid:e.project_id}))
        let payLod = (e.package_id != null && e.package_id != "") ? `pid=${e.project_id}&pkgid=${e.package_id}` : `pid=${e.project_id}`;
        dispatch(fPkgsAct(payLod))
    }
    const [totalProjectCount, setTotalProjectCount] = useState(0);
    useEffect(() => {
        let tempObjKey = [profileState.appAcc[0].business_unit, profileState.appAcc[0].bu_proj_count];
        let convertedObject = {
            [tempObjKey[0]]: tempObjKey[1]
        }
        let allBUObj = { ...profileState.appAcc[0].secondary_office_count, ...convertedObject };
        if (profileState.capb.findIndex((o) => o.PWSALPRJ === 'Y') >= 0) {
            setTotalProjectCount(allBUObj[profileState.bu])
        } else {
            setTotalProjectCount(profileState.appAcc[0].project_count)
        }
    }, [profileState.bu])

    useEffect(() => {
        if (projData === undefined || projData === null
            || (projData !== undefined && projData !== null && projData.length === 0)) {
            dispatch(showLoader(true))
            let tempObjKey = [profileState.appAcc[0].business_unit, profileState.appAcc[0].bu_proj_count];
            let convertedObject = {
                [tempObjKey[0]]: tempObjKey[1]
            }
            let allBUObj = { ...profileState.appAcc[0].secondary_office_count, ...convertedObject };
            if (profileState.capb.findIndex((o) => o.PWSALPRJ === 'Y') >= 0) {
                setTotalProjectCount(allBUObj[profileState.bu])
            } else {
                setTotalProjectCount(profileState.appAcc[0].project_count)
            }
            if (profileState.capb.findIndex((o) => o.PWSALPRJ === 'Y') >= 0) {
                setTimeout(() => {
                    if (eid && prof.appAcc.length > 0 && (profileState?.capb?.length > 0)) {
                        dispatch(fetchProjectsAct({ eid: eid, prjCnt: prof.appAcc[0].project_count, capabilities: profileState.capb, totalProjectCount: allBUObj[profileState.bu] }))
                    }
                }, 2000);
            } else {
                setTimeout(() => {
                    if (eid && prof.appAcc.length > 0 && (profileState?.capb?.length > 0)) {
                        dispatch(fetchProjectsAct({ eid: eid, prjCnt: prof.appAcc[0].project_count, capabilities: profileState.capb, totalProjectCount: totalProjectCount }))
                    }
                }, 2000);
            }
        }
    }, [eid, profileState.capb]);

    /*useEffect(() => {
        if (projData === undefined || projData === null
            || (projData !== undefined && projData !== null && projData.length === 0)) {
                dispatch(showLoader(true))
            if (eid && prof.appAcc.length>0){
            const prj_count = prof.appAcc[0].project_count ? prof.appAcc[0].project_count : 1; 
            var splitNumber = new Array(Math.floor(prj_count / 1500)).fill(1500).concat(prj_count % 1500); 
            console.log('==================splitNumber ',splitNumber)
            var fromNo = 0;
            var toNo = 0; 
            splitNumber.map((count, i) => {                                 
            setTimeout( () =>{
                    fromNo = toNo + 1;                           
                  toNo = count < 1500 ? prj_count : toNo + count;        

               dispatch(fetchProjectsAct({eid:eid,prjCnt:prof.appAcc[0].project_count,fromNo:fromNo,toNo:toNo}));
               console.log('==================fromNo ',fromNo ,' toNo   ',toNo)                            
            },i*3000);
        });
            }                    
            }
}, [eid]);*/

    let count = 0;
    const custStyles = { display: 'flex', justifyContent: 'right', flex: '1', flexDirection: 'row-reverse', marginRight: '-5px', marginLeft: '0px', fontWeight: 'bold' }
    const custStyles1 = { marginLeft: '-5px', fontWeight: 'bold' }
    const custStyles01 = { marginLeft: '-5px' }
    const custStyles0 = { display: 'flex', justifyContent: 'right', flex: '1', flexDirection: 'row-reverse', marginRight: '-5px', marginLeft: '0px' }
    const custStyles2 = { display: 'flex', justifyContent: 'right', flex: '1', flexDirection: 'row-reverse', marginRight: '0px', marginLeft: '0px', color: COLORS.green, fontWeight: 'bold' }
    const custStyles3 = { marginLeft: '2px', marginRight: '2px', fontSize: '17px', fontWeight: 'bold' }

    const onClickEdit = (e) => {
        eProj.updProj = true;
        eProj.data = e;
        eProj.due_date = new Date(e.due_date)
        eProj.last_mod_date = new Date(e.last_mod_date)
        setProj(eProj)
        dispatch(showUpdProj(eProj))
    }

    const onClikCopy = (e) => {

        eProj.copyProj = true;
        eProj.data = e;
        setProj(eProj)
        dispatch(showCopyProj(eProj));
    }

    return (
        <>
            <CopyProject />
            {!ctrlState.hideGrid &&
                <div style={{ overflow: 'auto', maxHeight: window.innerHeight / 1.35, marginTop: '5px' }}>
                    <div className='divwdt'>
                        <Grid container spacing={3}>
                            {
                                projData.map((projects, index) => {
                                    count++
                                    if (count > 50) {
                                        return;
                                    }
                                    return (
                                        <Grid item lg={3} key={index} style={{ maxWidth: "25%", marginTop: "10px" }}>
                                            <Card variant="outlined" id={projects.project_id} className="project-card" style={{ maxWidth: '300px', maxHeight: '270px', marginLeft: '15px', backgroundColor: "#f8f9fa" }} >
                                                <CardContent onClick={() => onCardClick(projects)}>
                                                    <Grid className="my-1">
                                                        <div className='d-flex'>
                                                            <Grid >
                                                                <div className='d-flex'>
                                                                    <div className="project-card-label " style={custStyles1}>
                                                                        {(projects.favorite.includes("Y")) && <BsStarFill className='reicn' style={{ marginBottom: '7px', color: '#DAA520' }} />}
                                                                        {(!projects.favorite.includes("Y")) && <BsStar className='reicn' style={{ marginBottom: '7px', color: '#DAA520' }} />}
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                            {/*<Col style={custStyles} >
                                <CardSubtitle className="project-card-label ">Master: {(projects.master_prj==="Y"?"Yes":"No")}</CardSubtitle>
                            </Col >   */                                                        }
                                                        </div>
                                                    </Grid>
                                                    <Grid className="my-1" >
                                                        <div className='d-flex'>
                                                            <Grid item md={6} sm={6} xs={12}>
                                                                <span className="project-card-label " style={custStyles1} > {t('Project Name')} </span>

                                                                <StyledTooltip className="arrow-hidden" title={projects.project_name} placement="bottom-start" disableInteractive>
                                                                    <span className="project-card-label" style={custStyles01}>{projects.project_name.length > 15 ? projects.project_name.substring(0, 15) + '...' : projects.project_name}</span></StyledTooltip>
                                                            </Grid>
                                                            <Grid item md={6} sm={6} xs={12}>
                                                                <span className="project-card-label" style={custStyles}> {t('Project Number')} </span>
                                                                <span className="project-card-label" style={custStyles0}>{projects.project_number.length > 15 ? projects.project_number.substring(0, 15) + '...' : projects.project_number}</span>
                                                            </Grid>
                                                        </div>
                                                    </Grid>
                                                    <Grid className="my-1" >
                                                            <div className='d-flex'>
                                                            <Grid item md={6} sm={6} xs={12}>
                                                                    <span className="project-card-label" style={custStyles1}>Project Manager</span>
                                                                    <span className="project-card-label" style={custStyles01}>
                                                                    {projects.lead_project_manager && projects.lead_project_manager.length > 15
                                                                    ? projects.lead_project_manager.substring(0, 15) + "..."
                                                                    : projects.lead_project_manager}
                                                                </span>
                                                                    </Grid>
                                                                    <Grid item md={6} sm={6} xs={12}>
                                                                    <span className="project-card-label" style={custStyles}>Project Engineer</span>
                                                                    <span className="project-card-label" style={custStyles0}>{(projects.lead_project_engineer||[].length > 15) ?projects.lead_project_engineer.substring(0,15)+'...':projects.project_engineer}</span>
                                                                    </Grid>                                    
                                                                    </div>  
                                                    </Grid>
                                                    <Grid className="my-1" >
                                                        <div className='d-flex'>
                                                            {/*<Col>
                                    <span className="project-card-label" style={custStyles1}>EPC</span>
                                    <span className="project-card-label" style={custStyles01}>{projects.epc||[].length>15?projects.epc.substring(0,15)+'...':projects.epc}</span>                                    
                                    </Col>*/}
                                                            <Grid item md={6} sm={6} xs={12}>
                                                                <span className="project-card-label" style={custStyles1}>{t('Status')}</span>
                                                                <span className="project-card-label" style={custStyles01}>{getPrjStatus(projStat, projects.project_status)}</span>
                                                            </Grid>
                                                            <Grid item md={6} sm={6} xs={12}>
                                                                <span className="project-card-label" style={custStyles}> {t('Start Date')}</span>
                                                                <span className="project-card-label" style={custStyles0}>{getDtfrmt(projects.start_date)}</span>
                                                            </Grid>
                                                            {/*<Col >
                                    <span className="project-card-label" style={custStyles}>Project Engineer</span>
                                    <span className="project-card-label" style={custStyles}>{projects.project_engineer}</span>
                                    </Col>  */}
                                                        </div>
                                                    </Grid>
                                                    {/*<Row className="my-1" >
                                  <div className='d-flex'>
                                    <Col>
                                    <span className="project-card-label" style={custStyles1}>End User</span>
                                    <span className="project-card-label" style={custStyles01}>{projects.end_user_cust}</span>
                                    </Col>
                                    </div>  
                                </Row>*/}
                                                    <Grid className="my-1" >
                                                        <div className='d-flex'>
                                                            {/*<Col>
                                    <span className="project-card-label" style={custStyles1}>Proj Manager</span>
                                    <span className="project-card-label" style={custStyles01}>{projects.project_manager}</span>
                                    </Col>
                                    <Col>
                                    <span className="project-card-label" style={custStyles1}>End User</span>
                                    <span className="project-card-label" style={custStyles01}>{projects.end_user_cust?projects.end_user_cust:null}</span>
                                    </Col>*/}
                                                        </div>
                                                    </Grid>
                                                </CardContent>
                                                <CardActions className="flex-end" style={{ backgroundColor: "#f8f9fa", border: '0px' }}>
                                                    <Grid container>
                                                        <Grid item>
                                                        </Grid>
                                                        <Grid style={custStyles2} >
                                                            {/*<MdDeleteOutline className='mb-2 mr-1 pl-3' style={custStyles3} /> */}
                                                            <MdOutlineModeEdit className='mb-2 mr-1 pl-3' style={custStyles3} onClick={() => { onClickEdit(projects) }} />
                                                            <IoCopyOutline className='mb-2 mr-3 pl-3' style={custStyles3} 
                                                                color={ isCopyCapb && projects.writecol === 'Y' ? COLORS.green : COLORS.disabledGrey }  
                                                                onClick={() => { if(isCopyCapb && projects.writecol === 'Y') onClikCopy(projects) }} 
                                                            />

                                                        </Grid>
                                                    </Grid>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    )
                                })
                            }

                        </Grid>
                        <br />
                    </div>
                </div>
            }
            {ctrlState.hideGrid /*&& projData.length > 0*/ &&
                <ProjGrid 
                    data={projData} 
                    advanceSearchFields={data.advanceSearchFields} 
                />
            }
        </>
    )
}

export default ProjectCards;